import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

// Super-admin gating is inherited from the parent `/platform` route's
// `requireSystemAdmin()` beforeLoad — no additional guard needed here.
const CostApprovalSettingsPage = lazy(
  () => import('~/features/platform/pages/cost-approval-settings-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/platform/cost-approval')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <CostApprovalSettingsPage />
    </Suspense>
  ),
});
